<template>
  <div class='dataapi_wrap'>
    <StockData :menuList="menuList" @changeActive="changeActive" @changeItemActive="changeItemActive">
        <!-- 插槽，右侧主体内容 -->
        <div slot="stock_detail" class="stock_detail">
            <!-- 右侧主体数据，第一栏数据简介+图 -->
            <!-- <ContentTop>
                <span slot="stockName">{{stockName}}</span>
                <div slot="stockDescription">{{stockDescription}}</div>
            </ContentTop> -->
            <div class="main_mid">
                <div class="top_tips ">
                    <div class="ml20">品种信息</div>
                </div>
                <div class="table_wrap">
                    <div v-for="(table,index) in (isShowMore ? futuresProduct : futuresProduct.slice(0,4))" :key="index" class="table_item">
                        <el-table :data="table" border :key="index" :cell-style="{textAlign:'center',padding:'5px 0px'}"  stripe  :header-cell-style="$core.table_header">
                            <el-table-column prop="name" label="品种名称"></el-table-column>
                            <el-table-column prop="code" label="合约代码"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="flex-around">
                    <el-button plain type="primary" @click="isShowMore = true" v-if="(futuresProduct.length > 4) && !isShowMore">查看更多</el-button>
                </div>
            </div>

            <!-- 第二栏获取数据 -->
            <div class="main_mid">
                <div class="top_tips ">
                    <span class="ml20">{{selectWhat}}</span>
                    <span class="ml20 cheack_out" @click="videoVisible=true"><i class="iconfont icon-chakan"></i>&nbsp;&nbsp;查看品种</span>
                </div>
                <!-- 关键字筛选 -->
                <div class="serch_lab flex-between left3">
                    <div class="is_choose">{{selectedWhat}}</div>
                    <div class="serch_box flex-between">
                        <el-autocomplete  v-model="options" prefix-icon="el-icon-search" :placeholder="placeholder" :fetch-suggestions="querySearch" :trigger-on-focus="false" @select="selectArr"></el-autocomplete>
                    </div>
                </div>
                <!-- 已选列表 -->
                <div class="serch_list left3 flex-start">
                    <span v-show="isShowTips" class="select_tips">{{selectTips}}</span>
                    <div class="list_item flex-between" v-for="(item,index) in securityList" :key="index">
                        <span>{{item}}</span><span class="el-icon-circle-close" @click="removeItem(index)" :key="index"></span>
                    </div>
                    <div class='delete_btn' v-show='!isShowTips' @click='clearSelectArr'>
                        <el-button type='danger' icon='el-icon-delete' circle></el-button>
                    </div>
                </div>
                <!-- 时间区间 -->
                <div class='top_tips mat40'><span class='ml20'>选择时间区间</span></div>
                <div class='time_select left3'>
                    <el-date-picker range-separator='至' start-placeholder='开始日期' :picker-options='pickerOptions'
                                    end-placeholder='结束日期' unlink-panels type='daterange' value-format='yyyy-MM-dd'
                                    v-model='timeRangeValue'></el-date-picker>
                </div>
                <div class='but_btn' style='cursor: pointer'>
                    <div class='donload_btn' @click='queryTheData'>查询数据</div>
                    <div></div>
                </div>
            </div>
            <!-- 数据预览-->
            <DataPreview
                v-if='whetherToShowAPreview'
                ref='dataPreview'
                :down-load-data='downLoadData'
                api-url='/ms_resource/futures/preview'
                :queryParameters='queryParameters'
            ></DataPreview>
        </div>
    </StockData>
    <!-- 弹窗 -->
    <el-dialog :title="exchangeName" :visible.sync="videoVisible" left width="55%" :key="exchangeName">
        <div class="futures_det">{{exchangeInfo}}</div>
    </el-dialog>
  </div>
</template>

<script>
import { futuresDetail, futuresMenu, futuresSearch } from '../../utils/api';
import DataPreview from '@/components/common/DataPreview';

export default {
    components: {
        DataPreview
    },
    data() {
        return {
            isShowMore: false,
            menuList: [],
            futuresProduct: [],
            futureArray: [{
                id: 0,
                name: '铜',
                code: 'Cu'
            }, {
            id:1,
            name:'铝',
            code:'Cu'
        },{
            id:2,
            name:'黄金',
            code:'Cu'
        },{
            id:3,
            name:'白银',
            code:'Cu'
        },{
            id:4,
            name:'钾',
            code:'Cu'
        },{
            id:5,
            name:'锡',
            code:'Cu'
        },{
            id:6,
            name:'铜',
            code:'Cu'
        },{
            id:7,
            name:'铝',
            code:'Cu'
        },{
            id:8,
            name:'黄金',
            code:'Cu'
        },{
            id:9,
            name:'白银',
            code:'Cu'
        },{
            id:10,
            name:'钾',
            code:'Cu'
        },{
            id:11,
            name:'锡',
            code:'Cu'
        },{
            id:12,
            name:'铜',
            code:'Cu'
        },{
            id:13,
            name:'铝',
            code:'Cu'
        },{
            id:14,
            name:'黄金',
            code:'Cu'
        },{
            id:15,
            name:'白银',
            code:'Cu'
        },{
            id:16,
            name:'钾',
            code:'Cu'
        },{
            id:17,
            name:'锡',
            code:'Cu'
        },],
        securityList:[],
        activeIndex:0,
        activeItemIndex:4,
        download:'数据下载',
        isActive:1,
        stockDescription:'',
        keyword:'',
        options:'',
        selectOptions:[],
        timeRangeValue:[],
        videoVisible:false,
        stockName:'',
        exchangeName:'',
            exchangeInfo: '',
            selectWhat: '选择合约品种',
            selectedWhat: '已选合约品种',
            placeholder: '输入合约品种名称/代码进行搜索',
            selectTips: '请在搜索栏输入合约品种名称/代码进行选择',
            pickerOptions: {
                disabledDate(data) {
                    return data && data.valueOf() >= new Date();
                }
            },
            queryParameters: {},
            whetherToShowAPreview: true
        }
    },
    created(){
        this.getLeftStokeMenu()
        this.getStockdetail()
    },
    computed:{
        // 是否显示删除键
        isShowTips(){
            return this.securityList.length <= 0 ? true : false
        }
    },
    methods:{
        // 获取左边侧边栏数据
        getLeftStokeMenu(){
            futuresMenu().then(res => {
                this.menuList = res.data
            }).catch(err=>{})
        },

        // el-submenu改变时获取index
        changeActive(index){
            this.activeIndex = index
        },

        // el-menu-item改变时操作
        changeItemActive(index){
            this.activeItemIndex = index
            this.getStockdetail()
            this.securityList = []
            this.timeRangeValue = []
            this.options = '';
            this.whetherToShowAPreview = false;
            // 华南指数
            if(index >= 9){
                this.selectWhat = '选择南华指数品种'
                this.selectedWhat = '已选指数品种'
                this.placeholder = '输入指数品种名称/代码进行搜索'
                this.selectTips = '请在搜索栏输入指数品种名称/代码进行选择'
            }else{
                this.selectWhat = '选择合约品种'
                this.selectedWhat = '已选合约品种'
                this.placeholder = '输入合约品种名称/代码进行搜索'
                this.selectTips = '请在搜索栏输入合约品种名称/代码进行选择'
            }
        },

        // 获取文本内容
        getStockdetail(){
            let params = {
                menuId:this.activeItemIndex,
                productNum:5
            }
            futuresDetail(params).then(res=>{
                this.isShowMore = false
                this.futuresProduct = res.data.futuresProduct
                this.stockDescription = res.data.description
                this.stockName = res.data.title
                this.exchangeName = res.data.exchangeName
                this.exchangeInfo = res.data.exchangeInfo
            }).catch(err=>{})
        },

        // 删除单个选项
        removeItem(id){
        　　this.securityList.splice(id,1)
        },

        // 模糊查询
        async querySearch(queryString, cb) {
            await futuresSearch({ keyword: queryString,menuId:this.activeItemIndex })
            .then(res => {
                if(!res.data.length){
                   return this.$message.error('该关键词下没有数据')
                }else{
                    cb(res.data);
                }
            })
            .catch(err => {});
        },

        // 获取所选的数组
        selectArr(item){
            // 不存在
            if(this.securityList.indexOf(item.value) == -1){
                if(item != ''){
                    this.securityList.push(item.value)
                    this.options = ''
                }
            }
            // 存在
            else {
                this.options = '';
                this.$message.warning('不能重复选择股票');
            }
        },

        // 清空全部选项
        clearSelectArr() {
            this.securityList = [];
        },
        // 预览数据
        queryTheData() {
            this.whetherToShowAPreview = true;
            if (this.securityList.length === 0) return this.$message.warning('请选择股票');
            if (!this.timeRangeValue[1] || !this.timeRangeValue[0]) return this.$message.warning('请选择时间区间');
            this.queryParameters = {
                afterTime: this.timeRangeValue[1],
                beforeTime: this.timeRangeValue[0],
                codes: this.securityList.map(item => {
                    let index = item.indexOf(' ');
                    return item.substring(0, index);
                }).join(',')
                ,
                menuId: this.activeItemIndex
            };
            setTimeout(() => {
                this.$refs.dataPreview.queryTheData();
            });
        },
        // 下载数据
        downLoadData() {
            // 字符串截取
            let selectCodes = this.securityList.map(item => {
                let index = item.indexOf(' ');
                return item = item.substring(0, index);
            });
            // 路径拼接
            let select = selectCodes.map(item => {
                return `codes=${item}&`;
            }).toString().split(',').join('')

            if(this.timeRangeValue[0] == undefined || !this.timeRangeValue[1] == undefined || selectCodes.length <= 0){
                this.$message.error('时间和股票必选')
            }else{
                location.href = `${this.$config.BASE_URL}/futures/export?${select}beforeTime=${this.timeRangeValue[0]}&afterTime=${this.timeRangeValue[1]}&adjust=&menuId=${this.activeItemIndex}`
                this.download = '数据下载中...';
                this.isActive = 2;
                setTimeout(() => {
                    this.download = '数据下载';
                    this.isActive = 1;
                }, 2000);
            }
        },
    }
}
</script>
<style scoped lang='scss'>
.table_wrap {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .table_item {
        width: 23%;
        margin: 15px 1%;

        /deep/ td {
            padding: 10px 0px !important;
            border-bottom: 1px solid #efefef;
        }
    }
}
.cheack_out{
    font-size: 18px;
    color: #002D72;
}
.cheack_out:hover{
    opacity: 0.8;
    cursor: pointer;
}
.futures_det{
    padding:0 50px 50px 50px;
    font-size: 18px;
    color: #271B63;
    line-height: 30px;
}
.icon-chakan{
    font-size: 18px;
}
/deep/ .el-dialog__close {
    font-size: 26px;
    font-weight: bold;
    color: #271B63;
}
/deep/ .el-dialog__header{
    padding-top: 50px;
}
/deep/ .el-dialog__title{
    margin-left: 50px;
    font-size: 22px;
    font-weight: bold;
    color: #271B63;
}
/deep/ .el-checkbox__inner {
    width: 18px;
    height: 18px;
    margin-right: 10px;
}
/deep/.el-checkbox__label {
    font-size: 20px;
}
.time_select{
    width: 400px;
    /deep/ .el-icon-date{
    font-size: 20px;
    }
}
.list_item{
    // width: 180px;
    padding: 30px 0 0 30px;
}
.check_box{
    width: 90%;
    .checkbox_list{
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
        .checkbox_item{
            width: 25%;
            margin-top: 20px;
        }
    }

}
 .main_mid{
    width: 90%;
    padding: 30px 80px 80px 80px ;
    border-radius: 10px 10px 0px 0px;
    margin-left: -1%;
    margin-top: 30px;
    background: #fff;
    .serch_list{
        min-height: 140px;
        border: 1px solid #002D72;
        margin-top: 30px;
        padding: 0 0 30px;
        display: flex;
        flex-wrap: wrap;
        .list_item{
            width: 15%;
            height: 50px;
            font-size: 18px;
            color: #271B63;
            margin:30px 2.5% 0 2.5%;
        }
        .list_item:hover{
            opacity: 0.8;
            cursor: pointer;
        }
    }
    .serch_box{
        /deep/ .el-input__inner{
        width: 300px;
        margin-right: 5px;
        }
    }
    .time_select{
        width: 400px;
        /deep/ .el-icon-date{
        font-size: 20px;
        }
    }
}

</style>
